module.exports = __webpack_public_path__ + "static/img/model-cake.fc1ae3b9.png";